import React from "react";
import moment from "moment";
import { formatMoney } from "../../services/utils/helpersFunc";
import SectionLayout, { DataField } from "./SectionLayout";

const BorrowersInformation = ({ loanRequest }) => {
  return (
    <SectionLayout title="Borrower's Information">
      <DataField label="First Name" value={loanRequest.first_name} />
      <DataField label="Last Name" value={loanRequest.last_name} />
      <DataField label="BVN" value={loanRequest.bvn} />
      <DataField label="Sex" value={loanRequest.gender} />
      <DataField label="Marital Status" value={loanRequest.marital_status} />
      <DataField
        label="Date of Birth"
        value={moment(loanRequest.dob).format("Do MMMM YYYY")}
      />
      <DataField label="Phone Number" value={loanRequest.phone} />
      <DataField label="Email Address" value={loanRequest.email} />
      <DataField label="Residential Address" value={loanRequest.address} />
      <DataField label="Nearest Landmark" value={loanRequest.landmark} />
      <DataField label="Rented/Owned" value={loanRequest.home_ownership} />
      <DataField label="Occupation" value={loanRequest.occupation} />
      <DataField label="Designation" value={loanRequest.designation} />
      <DataField label="Employer's Name" value={loanRequest.employer} />
      <DataField label="Office Number" value={loanRequest.office_no} />
      <DataField label="Office Mail" value={loanRequest.office_email} />
      <DataField
        label="Monthly Income"
        value={loanRequest.income && `₦ ${formatMoney(loanRequest.income)}`}
      />
      <DataField label="Loan Purpose" value={loanRequest.purpose} />
    </SectionLayout>
  );
};

export default BorrowersInformation;
